exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hue-palette-well[data-v-2f0c30b6]{border-radius:4px;height:40px;width:40px;margin:4px;cursor:pointer;-webkit-box-shadow:inset 1px 1px 1px rgba(0,0,0,.2);box-shadow:inset 1px 1px 1px rgba(0,0,0,.2)}", ""]);

// exports
